import React, { useState, createContext } from 'react';

export const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({});
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);

  const value = { snackbar, setSnackbar, snackbarIsOpen, setSnackbarIsOpen };

  return <SnackbarContext.Provider value={value}>{children}</SnackbarContext.Provider>;
};
